module.exports = __webpack_public_path__ + "img/gift-cards-4.1133187b.png";